(function($) {
  'use strict';

  const textSlider = {
    dom: function() {
      this.$slider = $('.js-text-slider');
    },

    slider: function() {
      this.$slider.each(function(index, element) {
        const splide = new Splide(element, {
          // type: 'slide',
          type: 'loop',
          arrows: false,
          pagination: true,
          autoplay: true,
          // focus     : 'center',
          perPage: 1,
          perMove: 1
        });
        splide.mount();
      });
    },

    ready: function() {
      this.dom();
      this.slider();
    }
  };

  $(function() { textSlider.ready(); });

})(jQuery);
